export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CustomDate: any;
  CustomDateTime: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
};

export type AddLikeMutation = {
  __typename?: 'AddLikeMutation';
  nominee?: Maybe<NomineeType>;
};

export type AddressInput = {
  value?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  federalDistrict?: Maybe<Scalars['String']>;
  regionFiasId?: Maybe<Scalars['String']>;
  regionKladrId?: Maybe<Scalars['String']>;
  regionIsoCode?: Maybe<Scalars['String']>;
  regionWithType?: Maybe<Scalars['String']>;
  regionType?: Maybe<Scalars['String']>;
  regionTypeFull?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  areaFiasId?: Maybe<Scalars['String']>;
  areaKladrId?: Maybe<Scalars['String']>;
  areaWithType?: Maybe<Scalars['String']>;
  areaType?: Maybe<Scalars['String']>;
  areaTypeFull?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  cityFiasId?: Maybe<Scalars['String']>;
  cityKladrId?: Maybe<Scalars['String']>;
  cityWithType?: Maybe<Scalars['String']>;
  cityType?: Maybe<Scalars['String']>;
  cityTypeFull?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityArea?: Maybe<Scalars['String']>;
  cityDistrictFiasId?: Maybe<Scalars['String']>;
  cityDistrictKladrId?: Maybe<Scalars['String']>;
  cityDistrictWithType?: Maybe<Scalars['String']>;
  cityDistrictType?: Maybe<Scalars['String']>;
  cityDistrictTypeFull?: Maybe<Scalars['String']>;
  cityDistrict?: Maybe<Scalars['String']>;
  settlementFiasId?: Maybe<Scalars['String']>;
  settlementKladrId?: Maybe<Scalars['String']>;
  settlementWithType?: Maybe<Scalars['String']>;
  settlementType?: Maybe<Scalars['String']>;
  settlementTypeFull?: Maybe<Scalars['String']>;
  settlement?: Maybe<Scalars['String']>;
  streetFiasId?: Maybe<Scalars['String']>;
  streetKladrId?: Maybe<Scalars['String']>;
  streetWithType?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  streetTypeFull?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  houseFiasId?: Maybe<Scalars['String']>;
  houseKladrId?: Maybe<Scalars['String']>;
  houseCadnum?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  houseTypeFull?: Maybe<Scalars['String']>;
  house?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  blockTypeFull?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  entrance?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  flatFiasId?: Maybe<Scalars['String']>;
  flatCadnum?: Maybe<Scalars['String']>;
  flatType?: Maybe<Scalars['String']>;
  flatTypeFull?: Maybe<Scalars['String']>;
  flat?: Maybe<Scalars['String']>;
  flatArea?: Maybe<Scalars['String']>;
  postalBox?: Maybe<Scalars['String']>;
  fiasId?: Maybe<Scalars['String']>;
  fiasCode?: Maybe<Scalars['String']>;
  fiasLevel?: Maybe<Scalars['String']>;
  kladrId?: Maybe<Scalars['String']>;
  geonameId?: Maybe<Scalars['String']>;
  capitalMarker?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  geoLat?: Maybe<Scalars['String']>;
  geoLon?: Maybe<Scalars['String']>;
  historyValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  unparsedParts?: Maybe<Scalars['String']>;
};

export type AddressType = {
  __typename?: 'AddressType';
  value?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  federalDistrict?: Maybe<Scalars['String']>;
  regionFiasId?: Maybe<Scalars['String']>;
  regionKladrId?: Maybe<Scalars['String']>;
  regionIsoCode?: Maybe<Scalars['String']>;
  regionWithType?: Maybe<Scalars['String']>;
  regionType?: Maybe<Scalars['String']>;
  regionTypeFull?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  areaFiasId?: Maybe<Scalars['String']>;
  areaKladrId?: Maybe<Scalars['String']>;
  areaWithType?: Maybe<Scalars['String']>;
  areaType?: Maybe<Scalars['String']>;
  areaTypeFull?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  cityFiasId?: Maybe<Scalars['String']>;
  cityKladrId?: Maybe<Scalars['String']>;
  cityWithType?: Maybe<Scalars['String']>;
  cityType?: Maybe<Scalars['String']>;
  cityTypeFull?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityArea?: Maybe<Scalars['String']>;
  cityDistrictFiasId?: Maybe<Scalars['String']>;
  cityDistrictKladrId?: Maybe<Scalars['String']>;
  cityDistrictWithType?: Maybe<Scalars['String']>;
  cityDistrictType?: Maybe<Scalars['String']>;
  cityDistrictTypeFull?: Maybe<Scalars['String']>;
  cityDistrict?: Maybe<Scalars['String']>;
  settlementFiasId?: Maybe<Scalars['String']>;
  settlementKladrId?: Maybe<Scalars['String']>;
  settlementWithType?: Maybe<Scalars['String']>;
  settlementType?: Maybe<Scalars['String']>;
  settlementTypeFull?: Maybe<Scalars['String']>;
  settlement?: Maybe<Scalars['String']>;
  streetFiasId?: Maybe<Scalars['String']>;
  streetKladrId?: Maybe<Scalars['String']>;
  streetWithType?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  streetTypeFull?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  houseFiasId?: Maybe<Scalars['String']>;
  houseKladrId?: Maybe<Scalars['String']>;
  houseCadnum?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  houseTypeFull?: Maybe<Scalars['String']>;
  house?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  blockTypeFull?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  entrance?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  flatFiasId?: Maybe<Scalars['String']>;
  flatCadnum?: Maybe<Scalars['String']>;
  flatType?: Maybe<Scalars['String']>;
  flatTypeFull?: Maybe<Scalars['String']>;
  flat?: Maybe<Scalars['String']>;
  flatArea?: Maybe<Scalars['String']>;
  postalBox?: Maybe<Scalars['String']>;
  fiasId?: Maybe<Scalars['String']>;
  fiasCode?: Maybe<Scalars['String']>;
  fiasLevel?: Maybe<Scalars['String']>;
  kladrId?: Maybe<Scalars['String']>;
  geonameId?: Maybe<Scalars['String']>;
  capitalMarker?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  geoLat?: Maybe<Scalars['String']>;
  geoLon?: Maybe<Scalars['String']>;
  historyValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  unparsedParts?: Maybe<Scalars['String']>;
};

export type AnswerInput = {
  pollSlug: Scalars['String'];
  questionId: Scalars['ID'];
  questionType: Scalars['String'];
  answer: Scalars['String'];
  speakerId?: Maybe<Scalars['ID']>;
};

export type ApplyForMemberTicketMutation = {
  __typename?: 'ApplyForMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

export type AwardType = {
  __typename?: 'AwardType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** name */
  name?: Maybe<Scalars['String']>;
  /** nominee */
  nominee?: Maybe<NomineeType>;
};

export type BroadcastType = {
  __typename?: 'BroadcastType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** Название трансляции */
  title?: Maybe<Scalars['String']>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** url */
  url?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Ссылка из Викторинуса */
  victorinusUrl?: Maybe<Scalars['String']>;
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  eventitem?: Maybe<Array<EventItemType>>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  track?: Maybe<Scalars['Boolean']>;
  usersByCategory?: Maybe<Array<UserType>>;
  speakerRequestsByCategory?: Maybe<Array<SpeakerRequestType>>;
  /** Speaker list */
  speakersByCategory?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Event list */
  eventsByCategory?: Maybe<Array<Maybe<EventType>>>;
  eventItemsByTrack?: Maybe<Array<EventItemType>>;
  sliderByCategory?: Maybe<Array<MainSliderType>>;
  eventGroupsByCategory?: Maybe<Array<EventGroupType>>;
  contentByCategory?: Maybe<Array<SimilarContentType>>;
  enrollmentsByCategory?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
};


export type CategoryTypeSpeakersByCategoryArgs = {
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  season?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};


export type CategoryTypeEventsByCategoryArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type ChatBotCheckType = {
  __typename?: 'ChatBotCheckType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  chatBot?: Maybe<Scalars['Boolean']>;
};

export type CinemaRegisterMutation = {
  __typename?: 'CinemaRegisterMutation';
  result?: Maybe<Scalars['String']>;
};

export type CinemaType = {
  __typename?: 'CinemaType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Идентификатор события */
  slug?: Maybe<Scalars['String']>;
  /** Вместимость площадки */
  capacity?: Maybe<Scalars['Int']>;
  placesLeft?: Maybe<Scalars['Int']>;
};

export type ContentType = {
  __typename?: 'ContentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** type */
  type?: Maybe<ContentTypeEnum>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** event */
  event?: Maybe<EventType>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** Обложка */
  cover?: Maybe<Scalars['String']>;
  /** Длительность в минутах */
  duration?: Maybe<Scalars['Int']>;
  /** Ручной скоринг */
  manualScore?: Maybe<Scalars['Int']>;
  /** Ссылка на видео */
  videoUrl?: Maybe<Scalars['String']>;
  /** Длина видео */
  videoLength?: Maybe<Scalars['String']>;
  /** Тело статьи */
  body?: Maybe<Scalars['String']>;
  mainPage?: Maybe<Scalars['Boolean']>;
  /** PDF/Презентация/Документ */
  document?: Maybe<Scalars['String']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  describeTags?: Maybe<Array<Maybe<TagType>>>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  coverUrl?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  similarContentByTags?: Maybe<Array<Maybe<SimilarContentType>>>;
  similarContentByAuthor?: Maybe<Array<Maybe<SimilarContentType>>>;
};


export type ContentTypeSimilarContentByTagsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type ContentTypeSimilarContentByAuthorArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ContentTypeEnum {
  /** Видео */
  Video = 'VIDEO',
  /** Статья */
  Article = 'ARTICLE',
  /** Матерьял */
  Material = 'MATERIAL'
}

export type CreateAddressMutation = {
  __typename?: 'CreateAddressMutation';
  address?: Maybe<AddressType>;
};

export type CreateAnswerMutation = {
  __typename?: 'CreateAnswerMutation';
  poll?: Maybe<PollType>;
};

export type CreateAuthorizeMutation = {
  __typename?: 'CreateAuthorizeMutation';
  userExists?: Maybe<Scalars['Boolean']>;
};

export type CreateLeagueInput = {
  category: Scalars['ID'];
};

export type CreateLeagueMutation = {
  __typename?: 'CreateLeagueMutation';
  user?: Maybe<UserType>;
};

export type CreateMemberTicketInput = {
  additionalInformation?: Maybe<Scalars['String']>;
};

export type CreateQuizRegistrationMutation = {
  __typename?: 'CreateQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type CreateTelegramUserMutation = {
  __typename?: 'CreateTelegramUserMutation';
  user?: Maybe<UserType>;
};

export type CreateUserQuestion = {
  __typename?: 'CreateUserQuestion';
  userQuestion?: Maybe<UserQuestionType>;
};




export type DateListType = {
  __typename?: 'DateListType';
  startTime?: Maybe<Scalars['DateTime']>;
};


export type DeleteJsonWebTokenCookie = {
  __typename?: 'DeleteJSONWebTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DeleteQuizRegistrationMutation = {
  __typename?: 'DeleteQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type DeleteRefreshTokenCookie = {
  __typename?: 'DeleteRefreshTokenCookie';
  deleted: Scalars['Boolean'];
};

export type DepartmentType = {
  __typename?: 'DepartmentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  /** номер отображения */
  number?: Maybe<Scalars['Int']>;
  /** родительская группа */
  parentDepartment?: Maybe<DepartmentType>;
  childDepartment?: Maybe<Array<Maybe<DepartmentType>>>;
  people?: Maybe<Array<PersonType>>;
  persons?: Maybe<Array<Maybe<PersonType>>>;
};

export type DocumentGroupType = {
  __typename?: 'DocumentGroupType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  documents?: Maybe<Array<Maybe<DocumentType>>>;
};

export type DocumentType = {
  __typename?: 'DocumentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Файл */
  file?: Maybe<Scalars['String']>;
  /** group */
  group?: Maybe<DocumentGroupType>;
  fileUrl?: Maybe<Scalars['String']>;
};

export type EnrollToEventMutation = {
  __typename?: 'EnrollToEventMutation';
  result?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

/** An enumeration. */
export enum EnrollmentStatusEnum {
  /** новый */
  New = 'NEW',
  /** в обработке */
  Inprogress = 'INPROGRESS',
  /** отклонен */
  Declined = 'DECLINED'
}

export type EnrollmentType = {
  __typename?: 'EnrollmentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** game */
  game?: Maybe<GameType>;
  /** team */
  team?: Maybe<TeamType>;
  /** quiz id */
  quizId?: Maybe<Scalars['String']>;
  semifinalist?: Maybe<Scalars['Boolean']>;
};

export type EventDayType = {
  __typename?: 'EventDayType';
  date?: Maybe<Scalars['Date']>;
  eventItems?: Maybe<Array<Maybe<EventItemType>>>;
};

export type EventGroupType = {
  __typename?: 'EventGroupType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Название (Eng) */
  nameEn?: Maybe<Scalars['String']>;
  /** Вводный текст */
  intro?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Дата старта */
  startDate?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания регистрации */
  enrollFinishDate?: Maybe<Scalars['CustomDateTime']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  /** Изображение */
  cover?: Maybe<Scalars['String']>;
  /** Картинка для мобильной версии */
  mobileImage?: Maybe<Scalars['String']>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** Коррекция часового пояса */
  timezoneCorrection?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  venue?: Maybe<VenueType>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  infoPartners?: Maybe<Array<Maybe<PartnerType>>>;
  partners?: Maybe<Array<Maybe<PartnerType>>>;
  headliners?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Мероприятия */
  events?: Maybe<Array<Maybe<EventType>>>;
  eventthrough?: Maybe<Array<EventThroughType>>;
  coverUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  eventsThrough?: Maybe<Array<Maybe<EventThroughType>>>;
  dateList?: Maybe<Array<Maybe<DateListType>>>;
};


export type EventGroupTypeEventsArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type EventItemType = {
  __typename?: 'EventItemType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок лекции/события */
  title?: Maybe<Scalars['String']>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** Краткое описание */
  description?: Maybe<Scalars['String']>;
  /** Slug ивента */
  slug?: Maybe<Scalars['String']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** broadcast */
  broadcast?: Maybe<BroadcastType>;
  /** опрос */
  poll?: Maybe<PollType>;
  active?: Maybe<Scalars['Boolean']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** трек */
  track?: Maybe<Array<CategoryType>>;
  /** EventPhoto list */
  programPhotos?: Maybe<Array<Maybe<EventPhotoType>>>;
  speakerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  photos?: Maybe<Array<Maybe<EventPhotoType>>>;
  albumCover?: Maybe<EventPhotoType>;
};


export type EventItemTypeProgramPhotosArgs = {
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
};

export type EventPhotoAlbumType = {
  __typename?: 'EventPhotoAlbumType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** name */
  name?: Maybe<Scalars['String']>;
  /** event */
  event?: Maybe<EventType>;
  /** EventPhoto list */
  photos?: Maybe<Array<EventPhotoType>>;
};


export type EventPhotoAlbumTypePhotosArgs = {
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};

export type EventPhotoType = {
  __typename?: 'EventPhotoType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** file */
  file?: Maybe<Scalars['String']>;
  album?: Maybe<EventPhotoAlbumType>;
  /** event item */
  eventItem?: Maybe<EventItemType>;
  isCover?: Maybe<Scalars['Boolean']>;
  fileUrl?: Maybe<Scalars['String']>;
};

export type EventThroughType = {
  __typename?: 'EventThroughType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Подзаголовок */
  subtitle?: Maybe<Scalars['String']>;
  event?: Maybe<Array<Maybe<EventType>>>;
  /** event group */
  eventGroup?: Maybe<EventGroupType>;
  /** order */
  order?: Maybe<Scalars['Int']>;
};

export type EventType = {
  __typename?: 'EventType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название ивента */
  name?: Maybe<Scalars['String']>;
  /** Название ивента (Eng) */
  nameEn?: Maybe<Scalars['String']>;
  /** Вводный текст */
  intro?: Maybe<Scalars['String']>;
  /** Описание ивента */
  description?: Maybe<Scalars['String']>;
  /** Slug ивента */
  slug?: Maybe<Scalars['String']>;
  /** base color */
  baseColor?: Maybe<Scalars['String']>;
  /** Дата старта */
  startDate?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания регистрации */
  enrollFinishDate?: Maybe<Scalars['CustomDateTime']>;
  /** Город проведения */
  city?: Maybe<Scalars['String']>;
  /** Место проведения */
  place?: Maybe<Scalars['String']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  /** Изображение */
  cover?: Maybe<Scalars['String']>;
  /** Видео */
  video?: Maybe<Scalars['String']>;
  /** Картинка для мобильной версии */
  mobileImage?: Maybe<Scalars['String']>;
  venue?: Maybe<VenueType>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** Коррекция часового пояса */
  timezoneCorrection?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  /** qr code */
  qrCode?: Maybe<Scalars['String']>;
  poll?: Maybe<Array<Maybe<PollType>>>;
  /** Информационный текст */
  afterEnrollInfo?: Maybe<Scalars['String']>;
  /** Ссылка */
  afterEnrollLinkUrl?: Maybe<Scalars['String']>;
  /** Заголовок Ссылки */
  afterEnrollLinkLabel?: Maybe<Scalars['String']>;
  requiredUserFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  autoRedirect?: Maybe<Scalars['Boolean']>;
  /** хук для хакатона */
  webhookUrl?: Maybe<Scalars['String']>;
  offRegistration?: Maybe<Scalars['Boolean']>;
  partners?: Maybe<Array<Maybe<PartnerType>>>;
  infoPartners?: Maybe<Array<Maybe<PartnerType>>>;
  headliners?: Maybe<Array<Maybe<SpeakerType>>>;
  universities?: Maybe<Array<Maybe<UniversitiesType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  users?: Maybe<Array<UserType>>;
  learnsByEvent?: Maybe<Array<LearnType>>;
  translations?: Maybe<Array<TranslationItemType>>;
  broadcasts?: Maybe<Array<Maybe<BroadcastType>>>;
  eventItems?: Maybe<Array<EventItemType>>;
  eventsBySlider?: Maybe<Array<MainSliderType>>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  eventAlbums?: Maybe<EventPhotoAlbumType>;
  eventGroupsByEvent?: Maybe<Array<EventGroupType>>;
  eventByEventThrough?: Maybe<Array<EventThroughType>>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  eventDays?: Maybe<Array<Maybe<EventDayType>>>;
  coverUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  learns?: Maybe<Array<Maybe<LearnType>>>;
  placesLeft?: Maybe<Scalars['Int']>;
  isUserEnrolled?: Maybe<Scalars['Boolean']>;
  currentEventItem?: Maybe<EventItemType>;
  album?: Maybe<EventPhotoAlbumType>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type GameType = {
  __typename?: 'GameType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  type: Type;
  /** Время окончания регистрации */
  registerOffDate?: Maybe<Scalars['CustomDateTime']>;
  /** ID игры из api quiz */
  quizGameId?: Maybe<Scalars['String']>;
  /** Ссылка на трансляцию */
  broadcast?: Maybe<Scalars['String']>;
  /** тур */
  round?: Maybe<RoundType>;
  ratingByGame?: Maybe<Array<QuizRatingType>>;
  enrollmentsByGame?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  enrollments?: Maybe<Array<Maybe<EnrollmentType>>>;
  ratings?: Maybe<Array<Maybe<QuizRatingType>>>;
};


export type LeadInput = {
  fullname: Scalars['String'];
  city: Scalars['String'];
  phone: Scalars['String'];
  birthDate?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  projectLink: Scalars['String'];
  address?: Maybe<AddressInput>;
  user?: Maybe<UserInput>;
  extra1?: Maybe<Scalars['String']>;
  extra2?: Maybe<Scalars['String']>;
  extra3?: Maybe<Scalars['String']>;
  extra4?: Maybe<Scalars['String']>;
  extra5?: Maybe<Scalars['String']>;
  extra6?: Maybe<Scalars['String']>;
  extra7?: Maybe<Scalars['String']>;
  extra8?: Maybe<Scalars['String']>;
  extra9?: Maybe<Scalars['String']>;
  extra10?: Maybe<Scalars['String']>;
  extra11?: Maybe<Scalars['String']>;
  extra12?: Maybe<Scalars['String']>;
  extra13?: Maybe<Scalars['String']>;
  extra14?: Maybe<Scalars['String']>;
  extra15?: Maybe<Scalars['String']>;
  extra16?: Maybe<Scalars['String']>;
};

export type LeadMutation = {
  __typename?: 'LeadMutation';
  lead?: Maybe<LeadType>;
};

export type LeadType = {
  __typename?: 'LeadType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** ФИО */
  fullname?: Maybe<Scalars['String']>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** Текстовое поле 1 */
  extra1?: Maybe<Scalars['String']>;
  /** Текстовое поле 2 */
  extra2?: Maybe<Scalars['String']>;
  /** Текстовое поле 3 */
  extra3?: Maybe<Scalars['String']>;
  /** Текстовое поле 4 */
  extra4?: Maybe<Scalars['String']>;
  /** Текстовое поле 5 */
  extra5?: Maybe<Scalars['String']>;
  /** Текстовое поле 6 */
  extra6?: Maybe<Scalars['String']>;
  /** Текстовое поле 7 */
  extra7?: Maybe<Scalars['String']>;
  /** Текстовое поле 8 */
  extra8?: Maybe<Scalars['String']>;
  /** Текстовое поле 9 */
  extra9?: Maybe<Scalars['String']>;
  /** Текстовое поле 10 */
  extra10?: Maybe<Scalars['String']>;
  /** Текстовое поле 11 */
  extra11?: Maybe<Scalars['String']>;
  /** Текстовое поле 12 */
  extra12?: Maybe<Scalars['String']>;
  /** Текстовое поле 13 */
  extra13?: Maybe<Scalars['String']>;
  /** Текстовое поле 14 */
  extra14?: Maybe<Scalars['String']>;
  /** Текстовое поле 15 */
  extra15?: Maybe<Scalars['String']>;
  /** Текстовое поле 16 */
  extra16?: Maybe<Scalars['String']>;
  /** Метка проекта */
  projectLink?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  address?: Maybe<AddressType>;
};

export type LeagueOfLecturersEnrollmentType = {
  __typename?: 'LeagueOfLecturersEnrollmentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Статус */
  status?: Maybe<EnrollmentStatusEnum>;
  /** Этап */
  stage?: Maybe<Scalars['Int']>;
  season?: Maybe<LeagueOfLecturersSeasonType>;
  /** Пользователь */
  user?: Maybe<UserType>;
  category?: Maybe<CategoryType>;
  /** Видеовизитка */
  videocard?: Maybe<Scalars['String']>;
  /** Название лекции */
  lectureName?: Maybe<Scalars['String']>;
  /** Краткое описание лекции */
  lectureShortDescription?: Maybe<Scalars['String']>;
  /** Видеолекция */
  lectureVideo?: Maybe<Scalars['String']>;
  /** Документ о согласии ч.1 (закрытая ссылка) */
  agreementFile?: Maybe<Scalars['String']>;
  /** Документ о согласии ч.2 (закрытая ссылка) */
  agreementFilePart2?: Maybe<Scalars['String']>;
  /** Тема выступления */
  performanceTheme?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Int']>;
};

export type LeagueOfLecturersSeasonType = {
  __typename?: 'LeagueOfLecturersSeasonType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Имя сезона */
  title?: Maybe<Scalars['String']>;
  /** application starts at */
  applicationStartsAt?: Maybe<Scalars['CustomDate']>;
  /** application finishes at */
  applicationFinishesAt?: Maybe<Scalars['CustomDate']>;
  /** season end date */
  seasonEndDate?: Maybe<Scalars['CustomDate']>;
  /** Speaker list */
  speakersBySeason?: Maybe<Array<Maybe<SpeakerType>>>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
};


export type LeagueOfLecturersSeasonTypeSpeakersBySeasonArgs = {
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  season?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};

export type LearnType = {
  __typename?: 'LearnType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** order */
  order?: Maybe<Scalars['Int']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
};

export type LeaveEventMutation = {
  __typename?: 'LeaveEventMutation';
  result?: Maybe<Scalars['String']>;
  event?: Maybe<EventType>;
};

export type MainSliderType = {
  __typename?: 'MainSliderType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Картинка */
  image?: Maybe<Scalars['String']>;
  /** Видео */
  video?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Scalars['String']>;
  /** Ссылка для перехода */
  url?: Maybe<Scalars['String']>;
  /** Дата */
  date?: Maybe<Scalars['CustomDate']>;
  /** Дата окончания */
  endDate?: Maybe<Scalars['CustomDate']>;
  active?: Maybe<Scalars['Boolean']>;
  /** Место проведения */
  venue?: Maybe<VenueType>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  /** category */
  category?: Maybe<Array<CategoryType>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  imageUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
};

export type MatchMemberTicketInput = {
  ticketNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
};

export type MatchMemberTicketMutation = {
  __typename?: 'MatchMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

/** An enumeration. */
export enum MemberTicketDiscountCardEnum {
  /** Нет */
  Empty = 'EMPTY',
  /** Студенты и аспиранты ВУЗов */
  UniStudent = 'UNI_STUDENT',
  /** Учащиеся СПО */
  SpoStudent = 'SPO_STUDENT',
  /** Пенсионер */
  Retiree = 'RETIREE'
}

/** An enumeration. */
export enum MemberTicketEducationalExperienceEnum {
  /** Отсутствует */
  Absent = 'ABSENT',
  /** До 1 года */
  Year = 'YEAR',
  /** 1-5 лет */
  SeveralYears = 'SEVERAL_YEARS',
  /** Более 5 лет */
  ManyYears = 'MANY_YEARS'
}

/** An enumeration. */
export enum MemberTicketStatusEnum {
  /** На рассмотрении */
  InProgress = 'IN_PROGRESS',
  /** Ожидает оплаты */
  AwaitingPayment = 'AWAITING_PAYMENT',
  /** Одобрена */
  Approved = 'APPROVED',
  /** Отклонена */
  Declined = 'DECLINED'
}

export type MemberTicketType = {
  __typename?: 'MemberTicketType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  user?: Maybe<UserType>;
  /** Опыт (стаж) просветительской работы в обществах “Знание” СССР или России */
  educationalExperience?: Maybe<MemberTicketEducationalExperienceEnum>;
  /** Льготная карта */
  discountCard?: Maybe<MemberTicketDiscountCardEnum>;
  /** Файл-подтверждение льготной категории (закрытая ссылка) */
  discountCardFile?: Maybe<Scalars['String']>;
  /** Статус */
  status?: Maybe<MemberTicketStatusEnum>;
  /** Номер билета */
  ticketNumber?: Maybe<Scalars['String']>;
  /** Дополнительная информация */
  additionalInformation?: Maybe<Scalars['String']>;
  /** Дата отклонения */
  denialDate?: Maybe<Scalars['CustomDate']>;
  /** Комментарий в случае отклонения заявки. */
  denialComment?: Maybe<Scalars['String']>;
  /** Имя, из членского билета */
  oldFirstName?: Maybe<Scalars['String']>;
  /** Фамилия, из членского билета */
  oldLastName?: Maybe<Scalars['String']>;
  /** Отчество, из членского билета */
  oldMiddleName?: Maybe<Scalars['String']>;
  /** Дата рождения, из членского билета */
  oldBirthDate?: Maybe<Scalars['CustomDate']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createTelegramUser?: Maybe<CreateTelegramUserMutation>;
  createLeagueEnrollment?: Maybe<CreateLeagueMutation>;
  updateLeagueEnrollment?: Maybe<UpdateLeagueMutation>;
  addLike?: Maybe<AddLikeMutation>;
  createAnswer?: Maybe<CreateAnswerMutation>;
  createQuizRegistration?: Maybe<CreateQuizRegistrationMutation>;
  updateQuizRegistration?: Maybe<UpdateQuizRegistrationMutation>;
  deleteQuizRegistration?: Maybe<DeleteQuizRegistrationMutation>;
  cinemaRegister?: Maybe<CinemaRegisterMutation>;
  enrollToEvent?: Maybe<EnrollToEventMutation>;
  leaveEvent?: Maybe<LeaveEventMutation>;
  createSpeakerRequest?: Maybe<SpeakerRequestMutation>;
  createAddress?: Maybe<CreateAddressMutation>;
  registerUser?: Maybe<RegisterUserMutation>;
  updateUser?: Maybe<UpdateUserMutation>;
  /** Obtain JSON Web Token mutation */
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verifyToken?: Maybe<Verify>;
  refreshToken?: Maybe<Refresh>;
  revokeToken?: Maybe<Revoke>;
  sendResetToken?: Maybe<ResetPasswordTokenMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  createSmsAuthorize?: Maybe<CreateAuthorizeMutation>;
  applyForMemberTicket?: Maybe<ApplyForMemberTicketMutation>;
  matchMemberTicket?: Maybe<MatchMemberTicketMutation>;
  updateMemberTicket?: Maybe<UpdateMemberTicketMutation>;
  createLead?: Maybe<LeadMutation>;
  createScan?: Maybe<ScanMutation>;
  createUserQuestion?: Maybe<CreateUserQuestion>;
  deleteTokenCookie?: Maybe<DeleteJsonWebTokenCookie>;
  deleteRefreshTokenCookie?: Maybe<DeleteRefreshTokenCookie>;
};


export type MutationCreateTelegramUserArgs = {
  input?: Maybe<TelegramUserInput>;
};


export type MutationCreateLeagueEnrollmentArgs = {
  input?: Maybe<CreateLeagueInput>;
};


export type MutationUpdateLeagueEnrollmentArgs = {
  input?: Maybe<UpdateLeagueInput>;
};


export type MutationAddLikeArgs = {
  nomineeSlug: Scalars['String'];
};


export type MutationCreateAnswerArgs = {
  input?: Maybe<Array<Maybe<AnswerInput>>>;
};


export type MutationCreateQuizRegistrationArgs = {
  comment?: Maybe<Scalars['String']>;
  firstGame: Scalars['Boolean'];
  gameId: Scalars['ID'];
  teamCity?: Maybe<Scalars['String']>;
  teamMembers?: Maybe<Scalars['Int']>;
  teamName?: Maybe<Scalars['String']>;
};


export type MutationUpdateQuizRegistrationArgs = {
  teamId: Scalars['ID'];
  teamMembers: Scalars['Int'];
};


export type MutationDeleteQuizRegistrationArgs = {
  enrollmentId: Scalars['ID'];
};


export type MutationCinemaRegisterArgs = {
  cinemaSlug?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fio?: Maybe<Scalars['String']>;
};


export type MutationEnrollToEventArgs = {
  eventSlug?: Maybe<Scalars['String']>;
};


export type MutationLeaveEventArgs = {
  eventSlug?: Maybe<Scalars['String']>;
};


export type MutationCreateSpeakerRequestArgs = {
  input?: Maybe<SpeakerRequestInput>;
};


export type MutationCreateAddressArgs = {
  input?: Maybe<AddressInput>;
};


export type MutationRegisterUserArgs = {
  input?: Maybe<UserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationTokenAuthArgs = {
  username: Scalars['String'];
  password: Scalars['String'];
};


export type MutationVerifyTokenArgs = {
  token?: Maybe<Scalars['String']>;
};


export type MutationRefreshTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


export type MutationRevokeTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


export type MutationSendResetTokenArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationResetPasswordArgs = {
  password1: Scalars['String'];
  password2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCreateSmsAuthorizeArgs = {
  phone: Scalars['String'];
};


export type MutationApplyForMemberTicketArgs = {
  input?: Maybe<CreateMemberTicketInput>;
};


export type MutationMatchMemberTicketArgs = {
  input?: Maybe<MatchMemberTicketInput>;
};


export type MutationUpdateMemberTicketArgs = {
  input?: Maybe<UpdateMemberTicketInput>;
};


export type MutationCreateLeadArgs = {
  input?: Maybe<LeadInput>;
};


export type MutationCreateScanArgs = {
  input?: Maybe<ScanInput>;
};


export type MutationCreateUserQuestionArgs = {
  input?: Maybe<QuestionInput>;
};

export type NomineeType = {
  __typename?: 'NomineeType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** type */
  type?: Maybe<NomineeTypeEnum>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  /** Краткое описание */
  preview?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Ссылка на видео */
  videoLink?: Maybe<Scalars['String']>;
  /** Загрузить видео */
  video?: Maybe<Scalars['String']>;
  /** Загрузить презентацию */
  presentation?: Maybe<Scalars['String']>;
  speaker?: Maybe<SpeakerType>;
  /** Номинация */
  nomination?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Maybe<AwardType>>>;
  imageUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  presentationUrl?: Maybe<Scalars['String']>;
  liked?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum NomineeTypeEnum {
  /** Спикер */
  Speaker = 'SPEAKER',
  /** Компания */
  Company = 'COMPANY',
  /** Проект */
  Project = 'PROJECT'
}

/** Obtain JSON Web Token mutation */
export type ObtainJsonWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type PageGroupType = {
  __typename?: 'PageGroupType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  /** родительская группа */
  parentGroup?: Maybe<PageGroupType>;
  childGroups?: Maybe<Array<Maybe<PageGroupType>>>;
  pages?: Maybe<Array<Maybe<PageType>>>;
};

export type PageType = {
  __typename?: 'PageType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['String']>;
  /** Тело страницы */
  body?: Maybe<Scalars['String']>;
  /** Дата */
  date?: Maybe<Scalars['CustomDate']>;
  /** group */
  group?: Maybe<PageGroupType>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
};

export type PartnerType = {
  __typename?: 'PartnerType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название партнера */
  name?: Maybe<Scalars['String']>;
  /** Метка партнера (slug) */
  slug?: Maybe<Scalars['String']>;
  /** logo */
  logo?: Maybe<Scalars['String']>;
  /** url */
  url?: Maybe<Scalars['String']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  /** Event list */
  partnersByEvent?: Maybe<Array<Maybe<EventType>>>;
  /** Event list */
  infoPartnersByEvent?: Maybe<Array<Maybe<EventType>>>;
  eventGroupsByInfoPartner?: Maybe<Array<EventGroupType>>;
  eventGroupsByPartner?: Maybe<Array<EventGroupType>>;
  logoUrl?: Maybe<Scalars['String']>;
};


export type PartnerTypePartnersByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};


export type PartnerTypeInfoPartnersByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type PersonType = {
  __typename?: 'PersonType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Бейдж */
  badge?: Maybe<Scalars['String']>;
  /** department */
  department?: Maybe<DepartmentType>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
};

export type PollType = {
  __typename?: 'PollType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Опрос */
  name?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  /** qr code */
  qrCode?: Maybe<Scalars['String']>;
  /** Event list */
  pollByEvent?: Maybe<Array<Maybe<EventType>>>;
  pollByEventItem?: Maybe<Array<EventItemType>>;
  questions?: Maybe<Array<Maybe<QuestionType>>>;
};


export type PollTypePollByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type PostType = {
  __typename?: 'PostType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  /** Изображение */
  image?: Maybe<Scalars['String']>;
  /** Изображение для моб. версии */
  mobileImage?: Maybe<Scalars['String']>;
  /** Тело новости */
  body?: Maybe<Scalars['String']>;
  /** Время новости */
  publishedAt?: Maybe<Scalars['CustomDateTime']>;
  mark?: Maybe<Scalars['Boolean']>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  imageUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum ProcurementStateEnum {
  /** Предстоящая */
  Pending = 'PENDING',
  /** Активная */
  Active = 'ACTIVE',
  /** Завершенная */
  Finished = 'FINISHED'
}

export type ProcurementType = {
  __typename?: 'ProcurementType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Номер закупки */
  regId?: Maybe<Scalars['String']>;
  /** Дата публикации */
  publishingDate?: Maybe<Scalars['CustomDate']>;
  /** Дата окончания приема заявок */
  closingDate?: Maybe<Scalars['CustomDate']>;
  /** Тип закупки */
  type?: Maybe<Scalars['String']>;
  /** Документация */
  documentation?: Maybe<Scalars['String']>;
  /** Итоги */
  act?: Maybe<Scalars['String']>;
  /** Начальная цена */
  startPrice?: Maybe<Scalars['Float']>;
  /** Статус закупки */
  state?: Maybe<ProcurementStateEnum>;
  /** Контактное лицо */
  contactsName?: Maybe<Scalars['String']>;
  /** Контактный телефон */
  contactsPhone?: Maybe<Scalars['String']>;
  /** Контактный емэйл */
  contactsEmail?: Maybe<Scalars['String']>;
  /** Электронная площадка */
  platformUrl?: Maybe<Scalars['String']>;
  actUrl?: Maybe<Scalars['String']>;
  documentationUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  search?: Maybe<SearchType>;
  leagueTopics?: Maybe<Array<Maybe<TopicType>>>;
  /** Nominee list */
  nominees?: Maybe<Array<Maybe<NomineeType>>>;
  nomineeBySlug?: Maybe<NomineeType>;
  polls?: Maybe<Array<Maybe<PollType>>>;
  pollBySlug?: Maybe<PollType>;
  seasons?: Maybe<Array<Maybe<SeasonType>>>;
  seasonBySlug?: Maybe<SeasonType>;
  games?: Maybe<Array<Maybe<GameType>>>;
  gameById?: Maybe<GameType>;
  currentGames?: Maybe<Array<Maybe<GameType>>>;
  currentSeason?: Maybe<Array<Maybe<SeasonType>>>;
  currentRound?: Maybe<Array<Maybe<RoundType>>>;
  chatBot?: Maybe<ChatBotCheckType>;
  /** Post list */
  posts?: Maybe<Array<PostType>>;
  postBySlug?: Maybe<PostType>;
  /** Procurement list */
  procurements?: Maybe<Array<ProcurementType>>;
  pageGroups?: Maybe<Array<Maybe<PageGroupType>>>;
  pageGroupBySlug?: Maybe<PageGroupType>;
  pageBySlug?: Maybe<PageType>;
  documentGroups?: Maybe<Array<Maybe<DocumentGroupType>>>;
  documentGroupBySlug?: Maybe<DocumentGroupType>;
  documentBySlug?: Maybe<DocumentType>;
  departments?: Maybe<Array<Maybe<DepartmentType>>>;
  departmentBySlug?: Maybe<DepartmentType>;
  personBySlug?: Maybe<PersonType>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  specialProjects?: Maybe<Array<Maybe<SpecialProjectType>>>;
  questionCategories?: Maybe<Array<Maybe<QuestionCategoryType>>>;
  tagCategory?: Maybe<Array<Maybe<TagCategoryType>>>;
  eventBySlug?: Maybe<EventType>;
  eventsBySlugs?: Maybe<Array<Maybe<EventType>>>;
  /** Speaker list */
  speakers?: Maybe<Array<SpeakerType>>;
  cinemas?: Maybe<Array<Maybe<CinemaType>>>;
  /** Event list */
  events?: Maybe<Array<EventType>>;
  mainSlider?: Maybe<Array<Maybe<MainSliderType>>>;
  eventItemById?: Maybe<EventItemType>;
  eventGroupBySlug?: Maybe<EventGroupType>;
  eventGroups?: Maybe<Array<Maybe<EventGroupType>>>;
  /** Content list */
  contents?: Maybe<Array<ContentType>>;
  contentBySlug?: Maybe<ContentType>;
  videoBySlug?: Maybe<ContentType>;
  articleBySlug?: Maybe<ContentType>;
  materialBySlug?: Maybe<ContentType>;
  contentsByThemeTag?: Maybe<Array<Maybe<ContentType>>>;
  contentsByDescribeTag?: Maybe<Array<Maybe<ContentType>>>;
  me?: Maybe<UserType>;
  addressNameByFiasId?: Maybe<Scalars['String']>;
  suggestAddress?: Maybe<Array<Maybe<AddressType>>>;
  suggestCity?: Maybe<Array<Maybe<AddressType>>>;
};


export type QuerySearchArgs = {
  query?: Maybe<Scalars['String']>;
  outputType?: Maybe<Scalars['String']>;
};


export type QueryNomineesArgs = {
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};


export type QueryNomineeBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryPollBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QuerySeasonBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryGamesArgs = {
  dateStart?: Maybe<Scalars['DateTime']>;
  dateEnd?: Maybe<Scalars['DateTime']>;
};


export type QueryGameByIdArgs = {
  gameId?: Maybe<Scalars['ID']>;
};


export type QueryCurrentGamesArgs = {
  date?: Maybe<Scalars['DateTime']>;
};


export type QueryCurrentSeasonArgs = {
  date?: Maybe<Scalars['DateTime']>;
};


export type QueryCurrentRoundArgs = {
  date?: Maybe<Scalars['DateTime']>;
};


export type QueryPostsArgs = {
  published?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};


export type QueryPostBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryProcurementsArgs = {
  state?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};


export type QueryPageGroupBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryPageBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryDocumentGroupBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryDocumentBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryDepartmentBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryPersonBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QuerySpecialProjectsArgs = {
  header?: Maybe<Scalars['Boolean']>;
};


export type QueryEventBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryEventsBySlugsArgs = {
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QuerySpeakersArgs = {
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  season?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};


export type QueryEventsArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
  startDateTime?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
  settlementId?: Maybe<Scalars['ID']>;
  cityId?: Maybe<Scalars['ID']>;
  areaId?: Maybe<Scalars['ID']>;
  regionId?: Maybe<Scalars['ID']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};


export type QueryMainSliderArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryEventItemByIdArgs = {
  eventItemId?: Maybe<Scalars['ID']>;
};


export type QueryEventGroupBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
};


export type QueryContentsArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  mainPage?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  searchQuery?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
};


export type QueryContentBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryVideoBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryArticleBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryMaterialBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryContentsByThemeTagArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryContentsByDescribeTagArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryAddressNameByFiasIdArgs = {
  regionId?: Maybe<Scalars['ID']>;
  areaId?: Maybe<Scalars['ID']>;
  cityId?: Maybe<Scalars['ID']>;
  settlementId?: Maybe<Scalars['ID']>;
};


export type QuerySuggestAddressArgs = {
  query?: Maybe<Scalars['String']>;
  fromBound?: Maybe<Scalars['String']>;
  toBound?: Maybe<Scalars['String']>;
};


export type QuerySuggestCityArgs = {
  query?: Maybe<Scalars['String']>;
};

export type QuestionCategoryType = {
  __typename?: 'QuestionCategoryType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  questionsByCategory?: Maybe<Array<UserQuestionType>>;
};

export type QuestionInput = {
  question: Scalars['String'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  choices?: Maybe<Array<Maybe<Scalars['String']>>>;
  allowMultiply?: Maybe<Scalars['Boolean']>;
  textarea?: Maybe<Scalars['Boolean']>;
  otherInput?: Maybe<Scalars['Boolean']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  textType?: Maybe<Scalars['String']>;
};

export type QuizRatingType = {
  __typename?: 'QuizRatingType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** ID */
  idQuiz?: Maybe<Scalars['Int']>;
  /** Место */
  place?: Maybe<Scalars['Int']>;
  /** Название команды */
  teamName?: Maybe<Scalars['String']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Первый раунд */
  roundOne?: Maybe<Scalars['Int']>;
  /** Второй раунд */
  roundTwo?: Maybe<Scalars['Int']>;
  /** Третий раунд */
  roundThree?: Maybe<Scalars['Int']>;
  /** Четвертый раунд */
  roundFour?: Maybe<Scalars['Int']>;
  /** Пятый раунд */
  roundFive?: Maybe<Scalars['Int']>;
  /** Шестой раунд */
  roundSix?: Maybe<Scalars['Int']>;
  /** Седьмой раунд */
  roundSeven?: Maybe<Scalars['Int']>;
  /** Время */
  time?: Maybe<Scalars['String']>;
  /** Итого */
  total?: Maybe<Scalars['Int']>;
  /** Игра */
  game?: Maybe<GameType>;
};

export type RatingsType = {
  __typename?: 'RatingsType';
  place?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  games?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type RegisterUserMutation = {
  __typename?: 'RegisterUserMutation';
  user?: Maybe<UserType>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  user?: Maybe<UserType>;
};

export type ResetPasswordTokenMutation = {
  __typename?: 'ResetPasswordTokenMutation';
  user?: Maybe<UserType>;
};

export type Revoke = {
  __typename?: 'Revoke';
  revoked: Scalars['Int'];
};

export type RoundType = {
  __typename?: 'RoundType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** Сезон */
  season?: Maybe<LeagueOfLecturersSeasonType>;
  gamesByRound?: Maybe<Array<GameType>>;
  semiFinals?: Maybe<Array<SemiFinalsType>>;
  games?: Maybe<Array<Maybe<GameType>>>;
  ratings?: Maybe<Array<Maybe<RatingsType>>>;
  semifinals?: Maybe<Array<Maybe<SemiFinalsType>>>;
};

export type ScanInput = {
  title: Scalars['String'];
  file: Scalars['String'];
  expire: Scalars['Date'];
};

export type ScanMutation = {
  __typename?: 'ScanMutation';
  user?: Maybe<UserType>;
};

export type SearchType = {
  __typename?: 'SearchType';
  events?: Maybe<Array<Maybe<EventType>>>;
  content?: Maybe<Array<Maybe<ContentType>>>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  news?: Maybe<Array<Maybe<PostType>>>;
};

export type SeasonType = {
  __typename?: 'SeasonType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Дата начала */
  dateStart?: Maybe<Scalars['CustomDateTime']>;
  /** Дата окончания */
  dateEnd?: Maybe<Scalars['CustomDateTime']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  roundsBySeason?: Maybe<Array<RoundType>>;
  rounds?: Maybe<Array<Maybe<RoundType>>>;
  ratings?: Maybe<Array<Maybe<RatingsType>>>;
};

export type SemiFinalsType = {
  __typename?: 'SemiFinalsType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название команды */
  teamName?: Maybe<Scalars['String']>;
  /** Город */
  city?: Maybe<Scalars['String']>;
  /** Тур */
  round?: Maybe<RoundType>;
};

export type SimilarContentType = {
  __typename?: 'SimilarContentType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** type */
  type?: Maybe<ContentTypeEnum>;
  /** Заголовок */
  title?: Maybe<Scalars['String']>;
  /** Slug */
  slug?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** event */
  event?: Maybe<EventType>;
  promoted?: Maybe<Scalars['Boolean']>;
  /** Обложка */
  cover?: Maybe<Scalars['String']>;
  /** Длительность в минутах */
  duration?: Maybe<Scalars['Int']>;
  /** Ручной скоринг */
  manualScore?: Maybe<Scalars['Int']>;
  /** Ссылка на видео */
  videoUrl?: Maybe<Scalars['String']>;
  /** Длина видео */
  videoLength?: Maybe<Scalars['String']>;
  /** Тело статьи */
  body?: Maybe<Scalars['String']>;
  mainPage?: Maybe<Scalars['Boolean']>;
  /** PDF/Презентация/Документ */
  document?: Maybe<Scalars['String']>;
  speakers?: Maybe<Array<Maybe<SpeakerType>>>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  /** Спец проекты */
  specialProject?: Maybe<Array<SpecialProjectType>>;
  themeTags?: Maybe<Array<Maybe<TagType>>>;
  describeTags?: Maybe<Array<Maybe<TagType>>>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  coverUrl?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  similarContentByTags?: Maybe<Array<Maybe<SimilarContentType>>>;
  similarContentByAuthor?: Maybe<Array<Maybe<SimilarContentType>>>;
};


export type SimilarContentTypeSimilarContentByTagsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type SimilarContentTypeSimilarContentByAuthorArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SpeakerRequestInput = {
  enrollToLeagueOfLecturers?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  performanceUrl?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  activity?: Maybe<Scalars['String']>;
};

export type SpeakerRequestMutation = {
  __typename?: 'SpeakerRequestMutation';
  speakerRequest?: Maybe<SpeakerRequestType>;
};

/** An enumeration. */
export enum SpeakerRequestStatusEnum {
  /** pending */
  Pending = 'PENDING',
  /** inprogress */
  Inprogress = 'INPROGRESS',
  /** approved */
  Approved = 'APPROVED',
  /** declined */
  Declined = 'DECLINED'
}

export type SpeakerRequestType = {
  __typename?: 'SpeakerRequestType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** user */
  user?: Maybe<UserType>;
  /** Статус заявки */
  status?: Maybe<SpeakerRequestStatusEnum>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Город проживания */
  city?: Maybe<Scalars['String']>;
  /** Сфера деятельности */
  activity?: Maybe<Scalars['String']>;
  /** Место работы */
  workPlace?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  /** Комментарии/Темы выступления */
  comments?: Maybe<Scalars['String']>;
  /** Ссылка на пример выступления */
  performanceUrl?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** email */
  email?: Maybe<Scalars['String']>;
  /** vk account */
  vkAccount?: Maybe<Scalars['String']>;
  /** youtube account */
  youtubeAccount?: Maybe<Scalars['String']>;
  /** instagram account */
  instagramAccount?: Maybe<Scalars['String']>;
  /** telegram account */
  telegramAccount?: Maybe<Scalars['String']>;
  /** facebook account */
  facebookAccount?: Maybe<Scalars['String']>;
  /** Дата отклонения */
  denialDate?: Maybe<Scalars['CustomDate']>;
  /** Комментарий в случае отклонения заявки. */
  denialComment?: Maybe<Scalars['String']>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
};

export type SpeakerType = {
  __typename?: 'SpeakerType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** user */
  user?: Maybe<UserType>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** Имя (Eng) */
  firstNameEn?: Maybe<Scalars['String']>;
  /** Фамилия (Eng) */
  lastNameEn?: Maybe<Scalars['String']>;
  /** Должность (Eng) */
  titleEn?: Maybe<Scalars['String']>;
  /** Биография/описание */
  description?: Maybe<Scalars['String']>;
  /** photo */
  photo?: Maybe<Scalars['String']>;
  /** big photo */
  bigPhoto?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthPlace?: Maybe<Scalars['String']>;
  /** Дата присоединения к РОЗ */
  joinedDate?: Maybe<Scalars['CustomDate']>;
  vkAccount?: Maybe<Scalars['String']>;
  facebookAccount?: Maybe<Scalars['String']>;
  /** twitter_account (old) */
  twitterAccount?: Maybe<Scalars['String']>;
  instagramAccount?: Maybe<Scalars['String']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  /** сезон */
  season?: Maybe<LeagueOfLecturersSeasonType>;
  /** Тематика (old) */
  category?: Maybe<Array<CategoryType>>;
  /** Event list */
  headlinersByEvent?: Maybe<Array<Maybe<EventType>>>;
  eventitem?: Maybe<Array<EventItemType>>;
  eventGroupsByHeadliner?: Maybe<Array<EventGroupType>>;
  content?: Maybe<Array<SimilarContentType>>;
  /** Nominee list */
  nominee?: Maybe<Array<Maybe<NomineeType>>>;
  photoUrl?: Maybe<Scalars['String']>;
  bigPhotoUrl?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
};


export type SpeakerTypeHeadlinersByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};


export type SpeakerTypeNomineeArgs = {
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type SpecialProjectType = {
  __typename?: 'SpecialProjectType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** Статус */
  status?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  smallPhoto?: Maybe<Scalars['String']>;
  /** Описание */
  description?: Maybe<Scalars['String']>;
  /** ссылка на спец проект */
  projectUrl?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  /** Порядок вывода */
  order?: Maybe<Scalars['Int']>;
  /** Event list */
  eventsByProject?: Maybe<Array<Maybe<EventType>>>;
  /** Post list */
  newsByProject?: Maybe<Array<Maybe<PostType>>>;
  contentByProject?: Maybe<Array<SimilarContentType>>;
};


export type SpecialProjectTypeEventsByProjectArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};


export type SpecialProjectTypeNewsByProjectArgs = {
  published?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
};

export type TagCategoryType = {
  __typename?: 'TagCategoryType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Тип */
  type?: Maybe<TagCategoryTypeEnum>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  tagsByCategory?: Maybe<Array<TagType>>;
  tags?: Maybe<Array<Maybe<TagType>>>;
};

/** An enumeration. */
export enum TagCategoryTypeEnum {
  /** тема */
  Theme = 'THEME',
  /** формат */
  Describe = 'DESCRIBE'
}

export type TagType = {
  __typename?: 'TagType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название */
  name?: Maybe<Scalars['String']>;
  /** slug */
  slug?: Maybe<Scalars['String']>;
  /** Категория тега */
  tagCategory?: Maybe<TagCategoryType>;
  contentByThemeTag?: Maybe<Array<SimilarContentType>>;
  contentByDescribeTag?: Maybe<Array<SimilarContentType>>;
};

export type TeamType = {
  __typename?: 'TeamType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Аватар команды */
  avatar?: Maybe<Scalars['String']>;
  /** Заголовок */
  name?: Maybe<Scalars['String']>;
  /** Город команды */
  city?: Maybe<Scalars['String']>;
  /** Количество игроков */
  members?: Maybe<Scalars['Int']>;
  firstGame?: Maybe<Scalars['Boolean']>;
  /** Откуда узнали о нас? */
  comment?: Maybe<Scalars['String']>;
  capitan?: Maybe<UserType>;
  enrollmentByTeam?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  enrollments?: Maybe<Array<Maybe<EnrollmentType>>>;
  avatarUrl?: Maybe<Scalars['String']>;
};

export type TelegramUserInput = {
  tgUserId: Scalars['Int'];
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
};

export type TelegramUserType = {
  __typename?: 'TelegramUserType';
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** пользователь roz */
  user?: Maybe<UserType>;
  /** tg user id */
  tgUserId?: Maybe<Scalars['Int']>;
  /** username */
  username?: Maybe<Scalars['String']>;
  /** first name */
  firstName?: Maybe<Scalars['String']>;
  /** last name */
  lastName?: Maybe<Scalars['String']>;
  /** photo url */
  photoUrl?: Maybe<Scalars['String']>;
  /** hash */
  hash?: Maybe<Scalars['String']>;
};

export type TopicType = {
  __typename?: 'TopicType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type TranslationItemType = {
  __typename?: 'TranslationItemType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Мероприятие */
  event?: Maybe<EventType>;
  /** Название трансляции */
  title?: Maybe<Scalars['String']>;
  /** Время начала */
  startTime?: Maybe<Scalars['CustomDateTime']>;
  /** Время окончания */
  finishTime?: Maybe<Scalars['CustomDateTime']>;
  /** url */
  url?: Maybe<Scalars['String']>;
};

export enum Type {
  Qualifying = 'QUALIFYING',
  Semifinal = 'SEMIFINAL',
  Final = 'FINAL',
  Joker = 'JOKER',
  Grandfinal = 'GRANDFINAL'
}

export type UniversitiesType = {
  __typename?: 'UniversitiesType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Наименование университета */
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressType>;
  user?: Maybe<Array<UserType>>;
  /** Event list */
  universitiesByEvent?: Maybe<Array<Maybe<EventType>>>;
};


export type UniversitiesTypeUniversitiesByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type UniversityType = {
  __typename?: 'UniversityType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** Наименование университета */
  name?: Maybe<Scalars['String']>;
  user?: Maybe<Array<UserType>>;
  /** Event list */
  universitiesByEvent?: Maybe<Array<Maybe<EventType>>>;
  universityAddress?: Maybe<Scalars['String']>;
};


export type UniversityTypeUniversitiesByEventArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type UpdateLeagueInput = {
  videocard?: Maybe<Scalars['String']>;
  lectureName?: Maybe<Scalars['String']>;
  lectureShortDescription?: Maybe<Scalars['String']>;
  lectureVideo?: Maybe<Scalars['String']>;
  agreementFile?: Maybe<Scalars['String']>;
  performanceTheme?: Maybe<Scalars['String']>;
  agreementFilePart2?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type UpdateLeagueMutation = {
  __typename?: 'UpdateLeagueMutation';
  user?: Maybe<UserType>;
};

export type UpdateMemberTicketInput = {
  discountCard?: Maybe<Scalars['String']>;
  discountCardFile?: Maybe<Scalars['String']>;
  educationalExperience?: Maybe<Scalars['String']>;
};

export type UpdateMemberTicketMutation = {
  __typename?: 'UpdateMemberTicketMutation';
  memberTicket?: Maybe<MemberTicketType>;
};

export type UpdateQuizRegistrationMutation = {
  __typename?: 'UpdateQuizRegistrationMutation';
  user?: Maybe<UserType>;
};

export type UpdateUserInput = {
  firstName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  addressDetail?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  birthPlace?: Maybe<Scalars['String']>;
  workPlace?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  regalia?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  passwordOld?: Maybe<Scalars['String']>;
  passwordNew?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  academicDegree?: Maybe<Scalars['String']>;
  passportSeries?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  passportReleaseDate?: Maybe<Scalars['Date']>;
  releaseDptCode?: Maybe<Scalars['String']>;
  releaseDptName?: Maybe<Scalars['String']>;
  registrationPlace?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  vkAccount?: Maybe<Scalars['String']>;
  youtubeAccount?: Maybe<Scalars['String']>;
  instagramAccount?: Maybe<Scalars['String']>;
  telegramAccount?: Maybe<Scalars['String']>;
  facebookAccount?: Maybe<Scalars['String']>;
  okAccount?: Maybe<Scalars['String']>;
  vkAvatar?: Maybe<Scalars['String']>;
  whichUniversity?: Maybe<Scalars['String']>;
};

export type UpdateUserMutation = {
  __typename?: 'UpdateUserMutation';
  user?: Maybe<UserType>;
};

export type UserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  phone: Scalars['String'];
  secretCode?: Maybe<Scalars['String']>;
  whereRegistration?: Maybe<Scalars['String']>;
};

export type UserQuestionType = {
  __typename?: 'UserQuestionType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  user?: Maybe<UserType>;
  questionCategory?: Maybe<QuestionCategoryType>;
  /** Текст вопроса */
  question?: Maybe<Scalars['String']>;
  check?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UserSexEnum {
  /** М */
  M = 'M',
  /** Ж */
  F = 'F'
}

export type UserType = {
  __typename?: 'UserType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** пароль */
  password?: Maybe<Scalars['String']>;
  /** последний вход */
  lastLogin?: Maybe<Scalars['CustomDateTime']>;
  /** Указывает, что пользователь имеет все права без явного их назначения. */
  isSuperuser?: Maybe<Scalars['Boolean']>;
  /** Отметьте, если пользователь может входить в административную часть сайта. */
  isStaff?: Maybe<Scalars['Boolean']>;
  /** Отметьте, если пользователь должен считаться активным. Уберите эту отметку вместо удаления учётной записи. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** дата регистрации */
  dateJoined?: Maybe<Scalars['CustomDateTime']>;
  /** Обязательное поле. Не более 150 символов. Только буквы, цифры и символы @/./+/-/_. */
  username?: Maybe<Scalars['String']>;
  /** Аватар */
  avatar?: Maybe<Scalars['String']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']>;
  /** Фамилия */
  lastName?: Maybe<Scalars['String']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['String']>;
  address?: Maybe<AddressType>;
  /** Адрес проживания */
  addressDetail?: Maybe<Scalars['String']>;
  /** Пол */
  sex?: Maybe<UserSexEnum>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['CustomDate']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']>;
  /** Место работы */
  workPlace?: Maybe<Scalars['String']>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  /** Регалии */
  regalia?: Maybe<Scalars['String']>;
  /** Образование */
  education?: Maybe<Scalars['String']>;
  /** Учёная степень/звание */
  academicDegree?: Maybe<Scalars['String']>;
  /** Серия паспорта */
  passportSeries?: Maybe<Scalars['String']>;
  /** Номер паспорта */
  passportNumber?: Maybe<Scalars['String']>;
  /** Дата выдачи */
  passportReleaseDate?: Maybe<Scalars['CustomDate']>;
  /** Номер подразделения */
  releaseDptCode?: Maybe<Scalars['String']>;
  /** Кем выдан */
  releaseDptName?: Maybe<Scalars['String']>;
  /** Место регистрации */
  registrationPlace?: Maybe<Scalars['String']>;
  /** Номер телефона */
  phone?: Maybe<Scalars['String']>;
  /** vk account */
  vkAccount?: Maybe<Scalars['String']>;
  /** youtube account */
  youtubeAccount?: Maybe<Scalars['String']>;
  /** instagram account */
  instagramAccount?: Maybe<Scalars['String']>;
  /** telegram account */
  telegramAccount?: Maybe<Scalars['String']>;
  /** facebook account */
  facebookAccount?: Maybe<Scalars['String']>;
  /** ok account */
  okAccount?: Maybe<Scalars['String']>;
  /** vk avatar */
  vkAvatar?: Maybe<Scalars['String']>;
  /** Откуда прошла регистрация */
  whereRegistration?: Maybe<Scalars['String']>;
  whichUniversityUserCome?: Maybe<UniversityType>;
  /** Тематика */
  category?: Maybe<Array<CategoryType>>;
  events?: Maybe<Array<Maybe<EventType>>>;
  memberTicket?: Maybe<MemberTicketType>;
  lead?: Maybe<Array<LeadType>>;
  speakerRequests?: Maybe<SpeakerRequestType>;
  speakers?: Maybe<SpeakerType>;
  enrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  quizTeam?: Maybe<TeamType>;
  questionsByUser?: Maybe<Array<UserQuestionType>>;
  leagueLecturersEnrollments?: Maybe<Array<LeagueOfLecturersEnrollmentType>>;
  telegramUser?: Maybe<TelegramUserType>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  avatarUrl?: Maybe<Scalars['String']>;
  team?: Maybe<TeamType>;
  registrationCurrentGame?: Maybe<Scalars['Boolean']>;
  leagueLecturersEnrollment?: Maybe<LeagueOfLecturersEnrollmentType>;
  rozAwardLikes?: Maybe<Scalars['Int']>;
};

export type VenueType = {
  __typename?: 'VenueType';
  /** Django object unique identification field */
  id: Scalars['ID'];
  /** created */
  created?: Maybe<Scalars['CustomDateTime']>;
  /** modified */
  modified?: Maybe<Scalars['CustomDateTime']>;
  /** Название места */
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressType>;
  /** Вместимость места */
  capacity?: Maybe<Scalars['Int']>;
  /** Детали */
  details?: Maybe<Scalars['String']>;
  /** Я.Карты */
  yandexMapCode?: Maybe<Scalars['String']>;
  /** Event list */
  events?: Maybe<Array<Maybe<EventType>>>;
  sliderByVenue?: Maybe<Array<MainSliderType>>;
  eventGroupsByVenue?: Maybe<Array<EventGroupType>>;
  yandexMapWidgetUrl?: Maybe<Scalars['String']>;
};


export type VenueTypeEventsArgs = {
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id?: Maybe<Scalars['ID']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type AddressFragment = (
  { __typename?: 'AddressType' }
  & Pick<AddressType, 'area' | 'areaFiasId' | 'areaKladrId' | 'areaType' | 'areaTypeFull' | 'areaWithType' | 'block' | 'blockType' | 'blockTypeFull' | 'capitalMarker' | 'city' | 'cityArea' | 'cityDistrict' | 'cityDistrictFiasId' | 'cityDistrictKladrId' | 'cityDistrictType' | 'cityDistrictTypeFull' | 'cityDistrictWithType' | 'cityFiasId' | 'cityKladrId' | 'cityType' | 'cityTypeFull' | 'cityWithType' | 'country' | 'countryIsoCode' | 'entrance' | 'federalDistrict' | 'fiasCode' | 'fiasId' | 'fiasLevel' | 'flat' | 'flatArea' | 'flatCadnum' | 'flatFiasId' | 'flatType' | 'flatTypeFull' | 'floor' | 'geoLat' | 'geoLon' | 'geonameId' | 'historyValues' | 'house' | 'houseCadnum' | 'houseFiasId' | 'houseKladrId' | 'houseType' | 'houseTypeFull' | 'kladrId' | 'postalBox' | 'postalCode' | 'region' | 'regionFiasId' | 'regionIsoCode' | 'regionKladrId' | 'regionType' | 'regionTypeFull' | 'regionWithType' | 'settlement' | 'settlementFiasId' | 'settlementKladrId' | 'settlementType' | 'settlementTypeFull' | 'settlementWithType' | 'street' | 'streetFiasId' | 'streetKladrId' | 'streetType' | 'streetTypeFull' | 'streetWithType' | 'timezone' | 'unparsedParts' | 'value'>
);

export type GetAddressQueryVariables = Exact<{
  term?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
}>;


export type GetAddressQuery = (
  { __typename?: 'Query' }
  & { suggestAddress?: Maybe<Array<Maybe<(
    { __typename?: 'AddressType' }
    & AddressFragment
  )>>> }
);

export type GetAddressNameByFiasIdQueryVariables = Exact<{
  settlementId?: Maybe<Scalars['ID']>;
  areaId?: Maybe<Scalars['ID']>;
  regionId?: Maybe<Scalars['ID']>;
  cityId?: Maybe<Scalars['ID']>;
}>;


export type GetAddressNameByFiasIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'addressNameByFiasId'>
);

export type GetCityQueryVariables = Exact<{
  term: Scalars['String'];
}>;


export type GetCityQuery = (
  { __typename?: 'Query' }
  & { suggestCity?: Maybe<Array<Maybe<(
    { __typename?: 'AddressType' }
    & AddressFragment
  )>>> }
);

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  password_confirm: Scalars['String'];
  token: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPasswordMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  )> }
);

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { tokenAuth?: Maybe<(
    { __typename?: 'ObtainJSONWebToken' }
    & Pick<ObtainJsonWebToken, 'payload' | 'token' | 'refreshToken' | 'refreshExpiresIn'>
  )> }
);

export type CategoryFragment = (
  { __typename?: 'CategoryType' }
  & Pick<CategoryType, 'id' | 'slug' | 'name' | 'description'>
);

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = (
  { __typename?: 'Query' }
  & { categories?: Maybe<Array<Maybe<(
    { __typename?: 'CategoryType' }
    & CategoryFragment
  )>>> }
);

export type GetArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetArticleBySlugQuery = (
  { __typename?: 'Query' }
  & { articleBySlug?: Maybe<(
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'id' | 'title' | 'description' | 'slug' | 'created' | 'coverUrl' | 'body'>
    & { categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, speakers?: Maybe<Array<Maybe<(
      { __typename?: 'SpeakerType' }
      & SpeakerFragment
    )>>> }
  )> }
);

export type GetContentsQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  promoted?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GetContentsQuery = (
  { __typename?: 'Query' }
  & { contents?: Maybe<Array<(
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'id' | 'type' | 'slug' | 'title' | 'created' | 'coverUrl' | 'promoted' | 'documentUrl' | 'videoUrl'>
    & { speakers?: Maybe<Array<Maybe<(
      { __typename?: 'SpeakerType' }
      & SpeakerFragment
    )>>>, event?: Maybe<(
      { __typename?: 'EventType' }
      & Pick<EventType, 'name'>
    )> }
  )>> }
);

export type GetVideoBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetVideoBySlugQuery = (
  { __typename?: 'Query' }
  & { videoBySlug?: Maybe<(
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'id' | 'slug' | 'title' | 'body' | 'created' | 'description' | 'coverUrl' | 'videoUrl'>
    & { categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, speakers?: Maybe<Array<Maybe<(
      { __typename?: 'SpeakerType' }
      & SpeakerFragment
    )>>> }
  )> }
);

export type DepartmentFragment = (
  { __typename?: 'DepartmentType' }
  & Pick<DepartmentType, 'id' | 'title' | 'slug'>
);

export type GetDepartmentsBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetDepartmentsBySlugQuery = (
  { __typename?: 'Query' }
  & { departmentBySlug?: Maybe<(
    { __typename?: 'DepartmentType' }
    & Pick<DepartmentType, 'description'>
    & { childDepartment?: Maybe<Array<Maybe<(
      { __typename?: 'DepartmentType' }
      & DepartmentFragment
    )>>>, parentDepartment?: Maybe<(
      { __typename?: 'DepartmentType' }
      & DepartmentFragment
    )>, persons?: Maybe<Array<Maybe<(
      { __typename?: 'PersonType' }
      & Pick<PersonType, 'id' | 'firstName' | 'lastName' | 'middleName' | 'slug' | 'badge' | 'email' | 'photo' | 'position'>
    )>>> }
    & DepartmentFragment
  )> }
);

export type DepartmentFragmentFragment = (
  { __typename?: 'DepartmentType' }
  & Pick<DepartmentType, 'id' | 'title' | 'slug'>
);

export type PersonFragmentFragment = (
  { __typename?: 'PersonType' }
  & Pick<PersonType, 'firstName' | 'lastName' | 'middleName' | 'badge' | 'email' | 'position'>
);

export type GetDepartmentsBySlugWithChildrenQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetDepartmentsBySlugWithChildrenQuery = (
  { __typename?: 'Query' }
  & { departmentBySlug?: Maybe<(
    { __typename?: 'DepartmentType' }
    & { childDepartment?: Maybe<Array<Maybe<(
      { __typename?: 'DepartmentType' }
      & { persons?: Maybe<Array<Maybe<(
        { __typename?: 'PersonType' }
        & PersonFragmentFragment
      )>>> }
      & DepartmentFragmentFragment
    )>>>, parentDepartment?: Maybe<(
      { __typename?: 'DepartmentType' }
      & DepartmentFragmentFragment
    )> }
    & DepartmentFragmentFragment
  )> }
);

export type GetDocumentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentGroupsQuery = (
  { __typename?: 'Query' }
  & { documentGroups?: Maybe<Array<Maybe<(
    { __typename?: 'DocumentGroupType' }
    & Pick<DocumentGroupType, 'title'>
    & { documents?: Maybe<Array<Maybe<(
      { __typename?: 'DocumentType' }
      & Pick<DocumentType, 'slug' | 'title' | 'fileUrl'>
    )>>> }
  )>>> }
);

export type EventFragment = (
  { __typename?: 'EventType' }
  & Pick<EventType, 'id' | 'name' | 'intro' | 'slug' | 'startDate' | 'finishDate' | 'enrollFinishDate' | 'isOffline' | 'offRegistration' | 'placesLeft' | 'coverUrl' | 'mobileImageUrl' | 'videoUrl'>
);

export type PartnerFragment = (
  { __typename?: 'PartnerType' }
  & Pick<PartnerType, 'id' | 'name' | 'url' | 'slug' | 'logoUrl'>
);

export type RegisterToEventMutationVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type RegisterToEventMutation = (
  { __typename?: 'Mutation' }
  & { enrollToEvent?: Maybe<(
    { __typename?: 'EnrollToEventMutation' }
    & Pick<EnrollToEventMutation, 'result'>
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & Pick<EventType, 'id'>
    )> }
  )> }
);

export type CancelEventRegistrationMutationVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type CancelEventRegistrationMutation = (
  { __typename?: 'Mutation' }
  & { leaveEvent?: Maybe<(
    { __typename?: 'LeaveEventMutation' }
    & Pick<LeaveEventMutation, 'result'>
    & { event?: Maybe<(
      { __typename?: 'EventType' }
      & Pick<EventType, 'id'>
    )> }
  )> }
);

export type GetAlbumsQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetAlbumsQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'name'>
    & { eventDays?: Maybe<Array<Maybe<(
      { __typename?: 'EventDayType' }
      & Pick<EventDayType, 'date'>
      & { eventItems?: Maybe<Array<Maybe<(
        { __typename?: 'EventItemType' }
        & Pick<EventItemType, 'id' | 'title' | 'startTime' | 'finishTime'>
        & { photos?: Maybe<Array<Maybe<(
          { __typename?: 'EventPhotoType' }
          & Pick<EventPhotoType, 'id' | 'fileUrl' | 'isCover'>
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export type GetEventQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
  photosLimit?: Maybe<Scalars['Int']>;
}>;


export type GetEventQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'description' | 'requiredUserFields' | 'afterEnrollInfo' | 'afterEnrollLinkLabel' | 'afterEnrollLinkUrl' | 'autoRedirect' | 'offRegistration'>
    & { categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, venue?: Maybe<(
      { __typename?: 'VenueType' }
      & Pick<VenueType, 'id' | 'name' | 'capacity' | 'details' | 'yandexMapWidgetUrl'>
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'city' | 'value'>
      )> }
    )>, headliners?: Maybe<Array<Maybe<(
      { __typename?: 'SpeakerType' }
      & Pick<SpeakerType, 'middleName'>
      & SpeakerFragment
    )>>>, eventDays?: Maybe<Array<Maybe<(
      { __typename?: 'EventDayType' }
      & Pick<EventDayType, 'date'>
      & { eventItems?: Maybe<Array<Maybe<(
        { __typename?: 'EventItemType' }
        & Pick<EventItemType, 'id' | 'title' | 'startTime' | 'finishTime' | 'description' | 'speakerIds'>
        & { track?: Maybe<Array<(
          { __typename?: 'CategoryType' }
          & Pick<CategoryType, 'id' | 'name'>
        )>>, broadcast?: Maybe<(
          { __typename?: 'BroadcastType' }
          & Pick<BroadcastType, 'id' | 'title' | 'startTime' | 'finishTime' | 'url' | 'published'>
        )>, speakers?: Maybe<Array<Maybe<(
          { __typename?: 'SpeakerType' }
          & SpeakerFragment
        )>>> }
      )>>> }
    )>>>, broadcasts?: Maybe<Array<Maybe<(
      { __typename?: 'BroadcastType' }
      & Pick<BroadcastType, 'id' | 'title' | 'startTime' | 'finishTime' | 'url' | 'imageUrl' | 'published'>
    )>>>, partners?: Maybe<Array<Maybe<(
      { __typename?: 'PartnerType' }
      & PartnerFragment
    )>>>, infoPartners?: Maybe<Array<Maybe<(
      { __typename?: 'PartnerType' }
      & PartnerFragment
    )>>>, learns?: Maybe<Array<Maybe<(
      { __typename?: 'LearnType' }
      & Pick<LearnType, 'slug' | 'order' | 'title' | 'description'>
    )>>>, album?: Maybe<(
      { __typename?: 'EventPhotoAlbumType' }
      & { photos?: Maybe<Array<(
        { __typename?: 'EventPhotoType' }
        & Pick<EventPhotoType, 'id' | 'file' | 'fileUrl'>
        & { eventItem?: Maybe<(
          { __typename?: 'EventItemType' }
          & Pick<EventItemType, 'id'>
        )> }
      )>> }
    )>, universities?: Maybe<Array<Maybe<(
      { __typename?: 'UniversitiesType' }
      & Pick<UniversitiesType, 'name'>
    )>>> }
    & EventFragment
  )> }
);

export type GetEventEnrollQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetEventEnrollQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'isUserEnrolled'>
  )> }
);

export type GetEventPollQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetEventPollQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'finishDate'>
    & { poll?: Maybe<Array<Maybe<(
      { __typename?: 'PollType' }
      & Pick<PollType, 'id' | 'slug'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'QuestionType' }
        & Pick<QuestionType, 'id' | 'min' | 'max' | 'type' | 'allowMultiply' | 'textType' | 'body' | 'choices'>
        & { speakers?: Maybe<Array<Maybe<(
          { __typename?: 'SpeakerType' }
          & SpeakerFragment
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export type GetEventScheduleQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetEventScheduleQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & { eventDays?: Maybe<Array<Maybe<(
      { __typename?: 'EventDayType' }
      & Pick<EventDayType, 'date'>
      & { eventItems?: Maybe<Array<Maybe<(
        { __typename?: 'EventItemType' }
        & Pick<EventItemType, 'id' | 'title' | 'startTime' | 'finishTime' | 'description' | 'speakerIds'>
        & { track?: Maybe<Array<(
          { __typename?: 'CategoryType' }
          & Pick<CategoryType, 'id' | 'name'>
        )>>, speakers?: Maybe<Array<Maybe<(
          { __typename?: 'SpeakerType' }
          & SpeakerFragment
        )>>> }
      )>>> }
    )>>> }
  )> }
);

export type GetEventsQueryVariables = Exact<{
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  promoted?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  ordering?: Maybe<Scalars['String']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  settlementId?: Maybe<Scalars['ID']>;
  areaId?: Maybe<Scalars['ID']>;
  regionId?: Maybe<Scalars['ID']>;
  cityId?: Maybe<Scalars['ID']>;
}>;


export type GetEventsQuery = (
  { __typename?: 'Query' }
  & { events?: Maybe<Array<(
    { __typename?: 'EventType' }
    & Pick<EventType, 'promoted'>
    & { venue?: Maybe<(
      { __typename?: 'VenueType' }
      & Pick<VenueType, 'id' | 'capacity'>
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'city'>
      )> }
    )>, categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, broadcasts?: Maybe<Array<Maybe<(
      { __typename?: 'BroadcastType' }
      & Pick<BroadcastType, 'id' | 'startTime' | 'finishTime' | 'published' | 'url'>
    )>>> }
    & EventFragment
  )>> }
);

export type EventGroupFragment = (
  { __typename?: 'EventGroupType' }
  & Pick<EventGroupType, 'id' | 'name' | 'startDate' | 'finishDate' | 'description' | 'isOffline' | 'coverUrl' | 'mobileImageUrl' | 'intro'>
  & { categories?: Maybe<Array<Maybe<(
    { __typename?: 'CategoryType' }
    & CategoryFragment
  )>>>, venue?: Maybe<(
    { __typename?: 'VenueType' }
    & { address?: Maybe<(
      { __typename?: 'AddressType' }
      & Pick<AddressType, 'city' | 'value'>
    )> }
  )> }
);

export type GetEventGroupBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetEventGroupBySlugQuery = (
  { __typename?: 'Query' }
  & { eventGroupBySlug?: Maybe<(
    { __typename?: 'EventGroupType' }
    & { eventsThrough?: Maybe<Array<Maybe<(
      { __typename?: 'EventThroughType' }
      & Pick<EventThroughType, 'title' | 'subtitle'>
      & { event?: Maybe<Array<Maybe<(
        { __typename?: 'EventType' }
        & Pick<EventType, 'slug'>
        & { broadcasts?: Maybe<Array<Maybe<(
          { __typename?: 'BroadcastType' }
          & Pick<BroadcastType, 'id' | 'title' | 'startTime' | 'finishTime' | 'url' | 'imageUrl' | 'published'>
        )>>> }
      )>>> }
    )>>>, headliners?: Maybe<Array<Maybe<(
      { __typename?: 'SpeakerType' }
      & Pick<SpeakerType, 'middleName'>
      & SpeakerFragment
    )>>>, partners?: Maybe<Array<Maybe<(
      { __typename?: 'PartnerType' }
      & PartnerFragment
    )>>>, infoPartners?: Maybe<Array<Maybe<(
      { __typename?: 'PartnerType' }
      & PartnerFragment
    )>>> }
    & EventGroupFragment
  )> }
);

export type LeagueLecturersEnrollmentFragment = (
  { __typename?: 'LeagueOfLecturersEnrollmentType' }
  & Pick<LeagueOfLecturersEnrollmentType, 'id' | 'stage' | 'status' | 'videocard' | 'lectureName' | 'lectureVideo' | 'agreementFile' | 'agreementFilePart2' | 'performanceTheme'>
  & { season?: Maybe<(
    { __typename?: 'LeagueOfLecturersSeasonType' }
    & LeagueLecturersSeasonFragment
  )> }
);

export type LeagueLecturersSeasonFragment = (
  { __typename?: 'LeagueOfLecturersSeasonType' }
  & Pick<LeagueOfLecturersSeasonType, 'id' | 'title' | 'applicationStartsAt' | 'applicationFinishesAt' | 'seasonEndDate'>
);

export type EnrollToLeagueLecturersMutationVariables = Exact<{
  input?: Maybe<CreateLeagueInput>;
}>;


export type EnrollToLeagueLecturersMutation = (
  { __typename?: 'Mutation' }
  & { createLeagueEnrollment?: Maybe<(
    { __typename?: 'CreateLeagueMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  )> }
);

export type UpdateLeagueLecturersEnrollmentMutationVariables = Exact<{
  input?: Maybe<UpdateLeagueInput>;
}>;


export type UpdateLeagueLecturersEnrollmentMutation = (
  { __typename?: 'Mutation' }
  & { updateLeagueEnrollment?: Maybe<(
    { __typename?: 'UpdateLeagueMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  )> }
);

export type GetLeagueTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeagueTopicsQuery = (
  { __typename?: 'Query' }
  & { leagueTopics?: Maybe<Array<Maybe<(
    { __typename?: 'TopicType' }
    & Pick<TopicType, 'id' | 'name'>
  )>>> }
);

export type MainSliderQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type MainSliderQuery = (
  { __typename?: 'Query' }
  & { mainSlider?: Maybe<Array<Maybe<(
    { __typename?: 'MainSliderType' }
    & Pick<MainSliderType, 'id' | 'order' | 'date' | 'endDate' | 'name' | 'description' | 'url' | 'imageUrl' | 'mobileImage' | 'videoUrl' | 'active'>
    & { categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, venue?: Maybe<(
      { __typename?: 'VenueType' }
      & Pick<VenueType, 'id'>
      & { address?: Maybe<(
        { __typename?: 'AddressType' }
        & Pick<AddressType, 'city'>
      )> }
    )>, events?: Maybe<Array<Maybe<(
      { __typename?: 'EventType' }
      & Pick<EventType, 'id' | 'isOffline'>
      & { broadcasts?: Maybe<Array<Maybe<(
        { __typename?: 'BroadcastType' }
        & Pick<BroadcastType, 'id' | 'url' | 'startTime' | 'finishTime' | 'published'>
      )>>> }
    )>>> }
  )>>> }
);

export type LikeNomineeMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type LikeNomineeMutation = (
  { __typename?: 'Mutation' }
  & { addLike?: Maybe<(
    { __typename?: 'AddLikeMutation' }
    & { nominee?: Maybe<(
      { __typename?: 'NomineeType' }
      & Pick<NomineeType, 'id' | 'liked'>
    )> }
  )> }
);

export type GetNomineeBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetNomineeBySlugQuery = (
  { __typename?: 'Query' }
  & { nomineeBySlug?: Maybe<(
    { __typename?: 'NomineeType' }
    & Pick<NomineeType, 'id' | 'slug' | 'type' | 'title' | 'liked' | 'preview' | 'description' | 'nomination' | 'imageUrl' | 'presentationUrl' | 'videoUrl'>
    & { speaker?: Maybe<(
      { __typename?: 'SpeakerType' }
      & SpeakerFragment
    )>, awards?: Maybe<Array<Maybe<(
      { __typename?: 'AwardType' }
      & Pick<AwardType, 'id' | 'name'>
    )>>> }
  )> }
);

export type GetNomineesQueryVariables = Exact<{
  type?: Maybe<Scalars['String']>;
}>;


export type GetNomineesQuery = (
  { __typename?: 'Query' }
  & { nominees?: Maybe<Array<Maybe<(
    { __typename?: 'NomineeType' }
    & Pick<NomineeType, 'id' | 'slug' | 'title' | 'liked' | 'preview' | 'imageUrl'>
    & { speaker?: Maybe<(
      { __typename?: 'SpeakerType' }
      & SpeakerFragment
    )>, awards?: Maybe<Array<Maybe<(
      { __typename?: 'AwardType' }
      & Pick<AwardType, 'id' | 'name'>
    )>>> }
  )>>> }
);

export type GetPageBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetPageBySlugQuery = (
  { __typename?: 'Query' }
  & { pageBySlug?: Maybe<(
    { __typename?: 'PageType' }
    & Pick<PageType, 'id' | 'slug' | 'created' | 'date' | 'title' | 'description' | 'body' | 'published'>
  )> }
);

export type GetPageGroupBySlugQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetPageGroupBySlugQuery = (
  { __typename?: 'Query' }
  & { pageGroupBySlug?: Maybe<(
    { __typename?: 'PageGroupType' }
    & Pick<PageGroupType, 'id' | 'slug' | 'title' | 'description' | 'published'>
    & { pages?: Maybe<Array<Maybe<(
      { __typename?: 'PageType' }
      & Pick<PageType, 'id' | 'slug' | 'title' | 'description' | 'body' | 'published' | 'image'>
    )>>> }
  )> }
);

export type GetEventItemPhotosQueryVariables = Exact<{
  eventItemId?: Maybe<Scalars['ID']>;
}>;


export type GetEventItemPhotosQuery = (
  { __typename?: 'Query' }
  & { eventItemById?: Maybe<(
    { __typename?: 'EventItemType' }
    & { photos?: Maybe<Array<Maybe<(
      { __typename?: 'EventPhotoType' }
      & Pick<EventPhotoType, 'id' | 'file' | 'fileUrl'>
    )>>> }
  )> }
);

export type GetEventPhotosQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetEventPhotosQuery = (
  { __typename?: 'Query' }
  & { eventBySlug?: Maybe<(
    { __typename?: 'EventType' }
    & { album?: Maybe<(
      { __typename?: 'EventPhotoAlbumType' }
      & { photos?: Maybe<Array<(
        { __typename?: 'EventPhotoType' }
        & Pick<EventPhotoType, 'id' | 'file' | 'fileUrl'>
      )>> }
    )> }
  )> }
);

export type PollQuestionFragment = (
  { __typename?: 'QuestionType' }
  & Pick<QuestionType, 'id' | 'min' | 'max' | 'type' | 'allowMultiply' | 'textType' | 'body' | 'choices'>
  & { speakers?: Maybe<Array<Maybe<(
    { __typename?: 'SpeakerType' }
    & SpeakerFragment
  )>>> }
);

export type AnswerForPollMutationVariables = Exact<{
  input?: Maybe<Array<Maybe<AnswerInput>> | Maybe<AnswerInput>>;
}>;


export type AnswerForPollMutation = (
  { __typename?: 'Mutation' }
  & { createAnswer?: Maybe<(
    { __typename?: 'CreateAnswerMutation' }
    & { poll?: Maybe<(
      { __typename?: 'PollType' }
      & Pick<PollType, 'id'>
    )> }
  )> }
);

export type GetPollQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetPollQuery = (
  { __typename?: 'Query' }
  & { pollBySlug?: Maybe<(
    { __typename?: 'PollType' }
    & Pick<PollType, 'id' | 'slug' | 'name'>
    & { questions?: Maybe<Array<Maybe<(
      { __typename?: 'QuestionType' }
      & PollQuestionFragment
    )>>> }
  )> }
);

export type GetPostQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetPostQuery = (
  { __typename?: 'Query' }
  & { postBySlug?: Maybe<(
    { __typename?: 'PostType' }
    & Pick<PostType, 'id' | 'title' | 'slug' | 'publishedAt' | 'imageUrl' | 'mobileImageUrl' | 'description' | 'body'>
  )> }
);

export type GetPostsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
}>;


export type GetPostsQuery = (
  { __typename?: 'Query' }
  & { posts?: Maybe<Array<(
    { __typename?: 'PostType' }
    & Pick<PostType, 'id' | 'title' | 'created' | 'slug' | 'imageUrl' | 'mobileImageUrl' | 'description' | 'mark' | 'published' | 'publishedAt'>
  )>> }
);

export type GetProcurementsQueryVariables = Exact<{
  state?: Maybe<Scalars['String']>;
}>;


export type GetProcurementsQuery = (
  { __typename?: 'Query' }
  & { procurements?: Maybe<Array<(
    { __typename?: 'ProcurementType' }
    & Pick<ProcurementType, 'id' | 'type' | 'title' | 'platformUrl' | 'publishingDate' | 'closingDate' | 'startPrice' | 'contactsName' | 'contactsEmail' | 'contactsPhone' | 'documentationUrl' | 'actUrl'>
  )>> }
);

export type QuestionCategoryFragment = (
  { __typename?: 'QuestionCategoryType' }
  & Pick<QuestionCategoryType, 'id' | 'name'>
);

export type QuestionFragment = (
  { __typename?: 'UserQuestionType' }
  & Pick<UserQuestionType, 'id' | 'question'>
);

export type CreateQuestionMutationVariables = Exact<{
  input?: Maybe<QuestionInput>;
}>;


export type CreateQuestionMutation = (
  { __typename?: 'Mutation' }
  & { createUserQuestion?: Maybe<(
    { __typename?: 'CreateUserQuestion' }
    & { userQuestion?: Maybe<(
      { __typename?: 'UserQuestionType' }
      & { questionCategory?: Maybe<(
        { __typename?: 'QuestionCategoryType' }
        & QuestionCategoryFragment
      )> }
      & QuestionFragment
    )> }
  )> }
);

export type GetQuestionsCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionsCategoriesQuery = (
  { __typename?: 'Query' }
  & { questionCategories?: Maybe<Array<Maybe<(
    { __typename?: 'QuestionCategoryType' }
    & QuestionCategoryFragment
  )>>> }
);

export type RegisterToQuizMutationVariables = Exact<{
  gameId: Scalars['ID'];
  teamName?: Maybe<Scalars['String']>;
  teamCity?: Maybe<Scalars['String']>;
  teamMembers?: Maybe<Scalars['Int']>;
  firstGame: Scalars['Boolean'];
  comment?: Maybe<Scalars['String']>;
}>;


export type RegisterToQuizMutation = (
  { __typename?: 'Mutation' }
  & { createQuizRegistration?: Maybe<(
    { __typename?: 'CreateQuizRegistrationMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  )> }
);

export type GetChatBotQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatBotQuery = (
  { __typename?: 'Query' }
  & { chatBot?: Maybe<(
    { __typename?: 'ChatBotCheckType' }
    & Pick<ChatBotCheckType, 'chatBot'>
  )> }
);

export type GetCurrentGamesQueryVariables = Exact<{
  date?: Maybe<Scalars['DateTime']>;
}>;


export type GetCurrentGamesQuery = (
  { __typename?: 'Query' }
  & { currentGames?: Maybe<Array<Maybe<(
    { __typename?: 'GameType' }
    & Pick<GameType, 'id' | 'title' | 'dateStart' | 'dateEnd' | 'registerOffDate' | 'broadcast'>
    & { ratings?: Maybe<Array<Maybe<(
      { __typename?: 'QuizRatingType' }
      & Pick<QuizRatingType, 'city' | 'teamName' | 'roundOne' | 'roundTwo' | 'roundThree' | 'roundFour' | 'roundFive' | 'roundSix' | 'roundSeven' | 'time' | 'total' | 'place'>
    )>>> }
  )>>> }
);

export type GetCurrentRoundQueryVariables = Exact<{
  date?: Maybe<Scalars['DateTime']>;
}>;


export type GetCurrentRoundQuery = (
  { __typename?: 'Query' }
  & { currentRound?: Maybe<Array<Maybe<(
    { __typename?: 'RoundType' }
    & Pick<RoundType, 'id' | 'title' | 'dateStart' | 'dateEnd'>
    & { games?: Maybe<Array<Maybe<(
      { __typename?: 'GameType' }
      & Pick<GameType, 'id' | 'title' | 'broadcast' | 'dateStart' | 'dateEnd' | 'registerOffDate' | 'type'>
    )>>> }
  )>>> }
);

export type GetCurrentSeasonQueryVariables = Exact<{
  date?: Maybe<Scalars['DateTime']>;
}>;


export type GetCurrentSeasonQuery = (
  { __typename?: 'Query' }
  & { currentSeason?: Maybe<Array<Maybe<(
    { __typename?: 'SeasonType' }
    & Pick<SeasonType, 'id'>
    & { rounds?: Maybe<Array<Maybe<(
      { __typename?: 'RoundType' }
      & Pick<RoundType, 'id'>
      & { semifinals?: Maybe<Array<Maybe<(
        { __typename?: 'SemiFinalsType' }
        & Pick<SemiFinalsType, 'id' | 'city' | 'teamName'>
      )>>> }
    )>>>, ratings?: Maybe<Array<Maybe<(
      { __typename?: 'RatingsType' }
      & Pick<RatingsType, 'avatar' | 'city' | 'games' | 'name' | 'place' | 'score'>
    )>>> }
  )>>> }
);

export type GetCurrentSeasonsQueryVariables = Exact<{
  date?: Maybe<Scalars['DateTime']>;
}>;


export type GetCurrentSeasonsQuery = (
  { __typename?: 'Query' }
  & { currentSeason?: Maybe<Array<Maybe<(
    { __typename?: 'SeasonType' }
    & Pick<SeasonType, 'id' | 'title' | 'dateStart' | 'dateEnd'>
    & { rounds?: Maybe<Array<Maybe<(
      { __typename?: 'RoundType' }
      & Pick<RoundType, 'id' | 'title'>
      & { games?: Maybe<Array<Maybe<(
        { __typename?: 'GameType' }
        & Pick<GameType, 'id' | 'title' | 'broadcast' | 'dateStart' | 'dateEnd' | 'registerOffDate' | 'type'>
      )>>> }
    )>>> }
  )>>> }
);

export type GetGameQueryVariables = Exact<{
  gameId?: Maybe<Scalars['ID']>;
}>;


export type GetGameQuery = (
  { __typename?: 'Query' }
  & { gameById?: Maybe<(
    { __typename?: 'GameType' }
    & Pick<GameType, 'id' | 'title' | 'type'>
    & { ratings?: Maybe<Array<Maybe<(
      { __typename?: 'QuizRatingType' }
      & Pick<QuizRatingType, 'city' | 'teamName' | 'roundOne' | 'roundTwo' | 'roundThree' | 'roundFour' | 'roundFive' | 'roundSix' | 'roundSeven' | 'time' | 'total' | 'place'>
    )>>> }
  )> }
);

export type GetGamesQueryVariables = Exact<{
  dateStart?: Maybe<Scalars['DateTime']>;
  dateEnd?: Maybe<Scalars['DateTime']>;
}>;


export type GetGamesQuery = (
  { __typename?: 'Query' }
  & { games?: Maybe<Array<Maybe<(
    { __typename?: 'GameType' }
    & Pick<GameType, 'id' | 'title' | 'dateStart' | 'dateEnd' | 'registerOffDate' | 'broadcast' | 'type'>
    & { ratings?: Maybe<Array<Maybe<(
      { __typename?: 'QuizRatingType' }
      & Pick<QuizRatingType, 'city' | 'teamName' | 'roundOne' | 'roundTwo' | 'roundThree' | 'roundFour' | 'roundFive' | 'roundSix' | 'roundSeven' | 'time' | 'total' | 'place'>
    )>>> }
  )>>> }
);

export type ApplyForRozMemberMutationVariables = Exact<{
  input?: Maybe<CreateMemberTicketInput>;
}>;


export type ApplyForRozMemberMutation = (
  { __typename?: 'Mutation' }
  & { applyForMemberTicket?: Maybe<(
    { __typename?: 'ApplyForMemberTicketMutation' }
    & { memberTicket?: Maybe<(
      { __typename?: 'MemberTicketType' }
      & Pick<MemberTicketType, 'ticketNumber'>
    )> }
  )> }
);

export type UpdateMemberTicketActionMutationVariables = Exact<{
  input?: Maybe<UpdateMemberTicketInput>;
}>;


export type UpdateMemberTicketActionMutation = (
  { __typename?: 'Mutation' }
  & { updateMemberTicket?: Maybe<(
    { __typename?: 'UpdateMemberTicketMutation' }
    & { memberTicket?: Maybe<(
      { __typename?: 'MemberTicketType' }
      & Pick<MemberTicketType, 'discountCard' | 'discountCardFile' | 'educationalExperience'>
    )> }
  )> }
);

export type SearchResultsQueryVariables = Exact<{
  query?: Maybe<Scalars['String']>;
  outputType?: Maybe<Scalars['String']>;
}>;


export type SearchResultsQuery = (
  { __typename?: 'Query' }
  & { search?: Maybe<(
    { __typename?: 'SearchType' }
    & { events?: Maybe<Array<Maybe<(
      { __typename?: 'EventType' }
      & Pick<EventType, 'id' | 'slug' | 'name' | 'coverUrl' | 'mobileImageUrl' | 'startDate' | 'finishDate' | 'isOffline'>
      & { broadcasts?: Maybe<Array<Maybe<(
        { __typename?: 'BroadcastType' }
        & Pick<BroadcastType, 'startTime' | 'finishTime' | 'published'>
      )>>> }
    )>>>, content?: Maybe<Array<Maybe<(
      { __typename?: 'ContentType' }
      & Pick<ContentType, 'id' | 'slug' | 'title' | 'coverUrl' | 'videoLength' | 'created'>
    )>>>, news?: Maybe<Array<Maybe<(
      { __typename?: 'PostType' }
      & Pick<PostType, 'id' | 'slug' | 'title' | 'imageUrl' | 'publishedAt'>
    )>>> }
  )> }
);

export type SpeakerFragment = (
  { __typename?: 'SpeakerType' }
  & Pick<SpeakerType, 'id' | 'title' | 'description' | 'firstName' | 'lastName' | 'photoUrl'>
);

export type BecomeSpeakerMutationVariables = Exact<{
  input?: Maybe<SpeakerRequestInput>;
}>;


export type BecomeSpeakerMutation = (
  { __typename?: 'Mutation' }
  & { createSpeakerRequest?: Maybe<(
    { __typename?: 'SpeakerRequestMutation' }
    & { speakerRequest?: Maybe<(
      { __typename?: 'SpeakerRequestType' }
      & Pick<SpeakerRequestType, 'id'>
    )> }
  )> }
);

export type GetSpeakersQueryVariables = Exact<{
  leagueOfLecturersWinner?: Maybe<Scalars['Boolean']>;
  season?: Maybe<Scalars['ID']>;
  showOnMainPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetSpeakersQuery = (
  { __typename?: 'Query' }
  & { speakers?: Maybe<Array<(
    { __typename?: 'SpeakerType' }
    & Pick<SpeakerType, 'bigPhotoUrl'>
    & SpeakerFragment
  )>> }
);

export type ShortSpecialProjectFragment = (
  { __typename?: 'SpecialProjectType' }
  & Pick<SpecialProjectType, 'id' | 'name' | 'projectUrl' | 'smallPhoto'>
);

export type SpecialProjectFragment = (
  { __typename?: 'SpecialProjectType' }
  & Pick<SpecialProjectType, 'id' | 'name' | 'photo' | 'projectUrl' | 'description'>
);

export type GetShortSpecialProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShortSpecialProjectQuery = (
  { __typename?: 'Query' }
  & { shortSpecialProject?: Maybe<Array<Maybe<(
    { __typename?: 'SpecialProjectType' }
    & ShortSpecialProjectFragment
  )>>> }
);

export type GetSpecialProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpecialProjectQuery = (
  { __typename?: 'Query' }
  & { specialProjects?: Maybe<Array<Maybe<(
    { __typename?: 'SpecialProjectType' }
    & SpecialProjectFragment
  )>>> }
);

export type MemberTicketFragment = (
  { __typename?: 'MemberTicketType' }
  & Pick<MemberTicketType, 'status' | 'ticketNumber' | 'educationalExperience' | 'discountCard' | 'discountCardFile' | 'denialDate'>
);

export type TelegramUserFragment = (
  { __typename?: 'TelegramUserType' }
  & Pick<TelegramUserType, 'tgUserId' | 'username' | 'firstName' | 'lastName' | 'photoUrl'>
);

export type TelegramUserCreationMutationVariables = Exact<{
  input?: Maybe<TelegramUserInput>;
}>;


export type TelegramUserCreationMutation = (
  { __typename?: 'Mutation' }
  & { createTelegramUser?: Maybe<(
    { __typename?: 'CreateTelegramUserMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & { telegramUser?: Maybe<(
        { __typename?: 'TelegramUserType' }
        & TelegramUserFragment
      )> }
    )> }
  )> }
);

export type SaveUserDataMutationVariables = Exact<{
  user?: Maybe<UpdateUserInput>;
}>;


export type SaveUserDataMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'UpdateUserMutation' }
    & { user?: Maybe<(
      { __typename?: 'UserType' }
      & Pick<UserType, 'id'>
    )> }
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'UserType' }
    & Pick<UserType, 'id' | 'password' | 'username' | 'avatarUrl' | 'vkAvatar' | 'firstName' | 'lastName' | 'middleName' | 'email' | 'sex' | 'birthDate' | 'birthPlace' | 'phone' | 'position' | 'workPlace' | 'registrationCurrentGame' | 'regalia' | 'passportSeries' | 'passportNumber' | 'passportReleaseDate' | 'releaseDptCode' | 'releaseDptName' | 'registrationPlace' | 'addressDetail' | 'education' | 'academicDegree' | 'instagramAccount' | 'facebookAccount' | 'telegramAccount' | 'youtubeAccount' | 'vkAccount' | 'okAccount'>
    & { whichUniversityUserCome?: Maybe<(
      { __typename?: 'UniversityType' }
      & Pick<UniversityType, 'name'>
    )>, category?: Maybe<Array<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>, categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryType' }
      & CategoryFragment
    )>>>, events?: Maybe<Array<Maybe<(
      { __typename?: 'EventType' }
      & { venue?: Maybe<(
        { __typename?: 'VenueType' }
        & Pick<VenueType, 'id'>
        & { address?: Maybe<(
          { __typename?: 'AddressType' }
          & Pick<AddressType, 'city'>
        )> }
      )> }
      & EventFragment
    )>>>, address?: Maybe<(
      { __typename?: 'AddressType' }
      & AddressFragment
    )>, quizTeam?: Maybe<(
      { __typename?: 'TeamType' }
      & Pick<TeamType, 'name' | 'avatar' | 'city' | 'firstGame' | 'avatarUrl'>
    )>, leagueLecturersEnrollment?: Maybe<(
      { __typename?: 'LeagueOfLecturersEnrollmentType' }
      & LeagueLecturersEnrollmentFragment
    )>, telegramUser?: Maybe<(
      { __typename?: 'TelegramUserType' }
      & TelegramUserFragment
    )>, memberTicket?: Maybe<(
      { __typename?: 'MemberTicketType' }
      & MemberTicketFragment
    )>, speakerRequests?: Maybe<(
      { __typename?: 'SpeakerRequestType' }
      & Pick<SpeakerRequestType, 'status' | 'denialDate'>
    )> }
  )> }
);
